// import { ISolicitudDocumentoTecnicoModel } from "../interfaces/solicitud/ISolicitudDocumentoTecnicoModel";

import { SolicitudSeccion } from "../common/enumModel";
import { ISolicitudDocumentoTecnicoModel } from "../interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel";

export class SolicitudDocumentoTecnicoModel implements ISolicitudDocumentoTecnicoModel {
    // idSolicitudDocumentacion: number;
    // nombre: string;    
    idSolicitudDocumentoTecnico: number;
    fechaVencimiento?: Date | undefined;
    nombreArchivo: string;
    rutaArchivo: string;
    idRequisito: number;
    requisito: string;
    idSolicitudDocumentoRequerido: number;
    documento: string;
    controlarFechas: boolean;

    idEstado: number;
    aprobado: boolean;
    observado: boolean;

    idDocumento: number;
    idMaestroDocumento:number;
    idConfiguracionDocumento: number;
    esRequisitoBloqueado: boolean;
    esPredeterminado: boolean;
    permiteVisor: boolean;
    completado: boolean;

    constructor(){
        this.idSolicitudDocumentoTecnico = 0;
        // this.idSolicitudDocumentacion = 0;
        // this.nombre = '';
        this.nombreArchivo = '';
        this.rutaArchivo = '';
        this.idRequisito = 0;
        this.requisito = '';
        this.idSolicitudDocumentoRequerido = 0;
        this.documento = '';
        this.controlarFechas = false;
        this.aprobado = false;
        this.observado = false;
        this.idEstado = 0;

        this.idDocumento = 0;
        this.idMaestroDocumento = 0;
        this.idConfiguracionDocumento = 0;
        this.esRequisitoBloqueado = false;
        this.esPredeterminado = false;
        this.permiteVisor = false;
        this.completado = false;
    }

    
}
